/*
 * Adapptio DarkMonacoTheme  monaco theme
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import monaco from "monaco-editor";

export const adapptioDarkMonacoTheme: monaco.editor.IStandaloneThemeData = {
	base: "vs-dark",
	inherit: true,
	rules: [
		{
			background: "292c33",
			token: ""
		},
		{
			foreground: "404080",
			background: "292c33",
			fontStyle: "italic",
			token: "comment.block"
		},
		{
			foreground: "ffffff",
			token: "string"
		},
		{
			foreground: "707090",
			token: "constant.language"
		},
		{
			foreground: "7090b0",
			token: "constant.numeric"
		},
		{
			fontStyle: "bold",
			token: "constant.numeric.integer.int32"
		},
		{
			fontStyle: "italic",
			token: "constant.numeric.integer.int64"
		},
		{
			fontStyle: "bold italic",
			token: "constant.numeric.integer.nativeint"
		},
		{
			fontStyle: "underline",
			token: "constant.numeric.floating-point.ocaml"
		},
		{
			foreground: "666666",
			token: "constant.character"
		},
		{
			foreground: "8080a0",
			token: "constant.language.boolean"
		},
		{
			foreground: "008080",
			token: "variable.language"
		},
		{
			foreground: "008080",
			token: "variable.other"
		},
		{
			foreground: "a080ff",
			token: "keyword"
		},
		{
			foreground: "a0a0ff",
			token: "keyword.operator"
		},
		{
			foreground: "ffffff",
			token: "keyword.other.decorator"
		},
		{
			fontStyle: "underline",
			token: "keyword.operator.infix.floating-point.ocaml"
		},
		{
			fontStyle: "underline",
			token: "keyword.operator.prefix.floating-point.ocaml"
		},
		{
			foreground: "c080c0",
			token: "keyword.other.directive"
		},
		{
			foreground: "c080c0",
			fontStyle: "underline",
			token: "keyword.other.directive.line-number"
		},
		{
			foreground: "80a0ff",
			token: "keyword.control"
		},
		{
			foreground: "b0fff0",
			token: "storage"
		},
		{
			foreground: "60b0ff",
			token: "entity.name.type.variant"
		},
		{
			foreground: "60b0ff",
			fontStyle: "italic",
			token: "storage.type.variant.polymorphic"
		},
		{
			foreground: "60b0ff",
			fontStyle: "italic",
			token: "entity.name.type.variant.polymorphic"
		},
		{
			foreground: "b000b0",
			token: "entity.name.type.module"
		},
		{
			foreground: "b000b0",
			fontStyle: "underline",
			token: "entity.name.type.module-type.ocaml"
		},
		{
			foreground: "a00050",
			token: "support.other"
		},
		{
			foreground: "70e080",
			token: "entity.name.type.class"
		},
		{
			foreground: "70e0a0",
			token: "entity.name.type.class-type"
		},
		{
			foreground: "50a0a0",
			token: "entity.name.function"
		},
		{
			foreground: "80b0b0",
			token: "variable.parameter"
		},
		{
			foreground: "3080a0",
			token: "entity.name.type.token"
		},
		{
			foreground: "3cb0d0",
			token: "entity.name.type.token.reference"
		},
		{
			foreground: "90e0e0",
			token: "entity.name.function.non-terminal"
		},
		{
			foreground: "c0f0f0",
			token: "entity.name.function.non-terminal.reference"
		},
		{
			foreground: "009090",
			token: "entity.name.tag"
		},
		{
			background: "292c33",
			token: "support.constant"
		},
		{
			foreground: "400080",
			background: "ffff00",
			fontStyle: "bold",
			token: "invalid.illegal"
		},
		{
			foreground: "292c33",
			background: "cc66ff",
			token: "invalid.deprecated"
		},
		{
			background: "40008054",
			token: "source.camlp4.embedded"
		},
		{
			foreground: "805080",
			token: "punctuation"
		}
	],
	colors: {
		"editor.foreground": "#ffffff",
		"editor.background": "#292c33",
		"editor.selectionBackground": "#444a57",
		"editor.lineHighlightBackground": "#30333b",
		"editorCursor.foreground": "#7070FF",
		"editorWhitespace.foreground": "#BFBFBF"
	}
};
